import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TemplateDashboard\GetTemplateDashboardListController::__invoke
* @see app/Http/Controllers/TemplateDashboard/GetTemplateDashboardListController.php
* @route '/api/template-dashboard'
*/
const GetTemplateDashboardListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTemplateDashboardListController.url(options),
    method: 'get',
})

GetTemplateDashboardListController.definition = {
    methods: ["get","head"],
    url: '/api/template-dashboard',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\TemplateDashboard\GetTemplateDashboardListController::__invoke
* @see app/Http/Controllers/TemplateDashboard/GetTemplateDashboardListController.php
* @route '/api/template-dashboard'
*/
GetTemplateDashboardListController.url = (options?: RouteQueryOptions) => {
    return GetTemplateDashboardListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboard\GetTemplateDashboardListController::__invoke
* @see app/Http/Controllers/TemplateDashboard/GetTemplateDashboardListController.php
* @route '/api/template-dashboard'
*/
GetTemplateDashboardListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTemplateDashboardListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\TemplateDashboard\GetTemplateDashboardListController::__invoke
* @see app/Http/Controllers/TemplateDashboard/GetTemplateDashboardListController.php
* @route '/api/template-dashboard'
*/
GetTemplateDashboardListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetTemplateDashboardListController.url(options),
    method: 'head',
})

export default GetTemplateDashboardListController